import alt from '../components/alt';

class LocalesActions {
  setCurrentLocale(locale) {
    return locale;
  }

  setShowUkLocale(showUkLocale) {
    return showUkLocale;
  }
}

export default alt.createActions(LocalesActions);
